import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/Elements';
import { Currency, IntervalBillingMode, ProductTypes } from '@/types';

export type NotificationTemplatesProps = {
  onActionButton: (
    product: ProductTypes,
    currency: Currency,
    intervalBillingMode: IntervalBillingMode | null
  ) => void;
  onCancelButton: () => void;
  product: ProductTypes;
  currency: Currency;
  intervalBillingMode: IntervalBillingMode | null;
};

export const PaymentReminderTemplate = ({
  onActionButton,
  onCancelButton,
  product,
  currency,
  intervalBillingMode,
}: NotificationTemplatesProps) => {
  const { t } = useTranslation();
  return (
    <span className="flex justify-between mt-3">
      <Button
        variant="ghost"
        type="button"
        onClick={onCancelButton}
        size="free"
        className="ml-4 py-2 px-5 text-xs bg-transparent hover:bg-yellow-200"
      >
        {t('Forms.cancelPendingProductShort')}
      </Button>

      <Button
        variant="primary"
        type="button"
        size="free"
        onClick={() => onActionButton(product, currency, intervalBillingMode)}
      >
        {t('Forms.Checkout.reminder.goToCheckoutShort')}
      </Button>
    </span>
  );
};
